(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["practive-record-playback"] && !window.DesignMode) return;
  try {
    

   ////////// start recorder js //////////
   
   (function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Recorder = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return 0="" 36="" s})({1:[function(require,module,exports){="" "use="" strict";="" module.exports="require(&quot;./recorder&quot;).Recorder;" },{".="" recorder":2}],2:[function(require,module,exports){="" 'use="" strict';="" var="" _createClass="(function" ()="" {="" function="" defineProperties(target,="" props)="" for="" (var="" i="0;" <="" props.length;="" i++)="" descriptor="props[i];descriptor.enumerable" =="" descriptor.enumerable="" ||="" false;descriptor.configurable="true;if" ("value"="" in="" descriptor)="" descriptor.writable="true;Object.defineProperty(target," descriptor.key,="" descriptor);="" }="" }return="" (Constructor,="" protoProps,="" staticProps)="" if="" (protoProps)="" defineProperties(Constructor.prototype,="" protoProps);if="" (staticProps)="" defineProperties(Constructor,="" staticProps);return="" Constructor;="" };="" })();="" Object.defineProperty(exports,="" "__esModule",="" value:="" true="" });="" exports.Recorder="undefined;" _inlineWorker="require('inline-worker');" _inlineWorker2="_interopRequireDefault(_inlineWorker);" _interopRequireDefault(obj)="" return="" obj="" &&="" obj.__esModule="" ?="" :="" default:="" _classCallCheck(instance,="" Constructor)="" (!(instance="" instanceof="" Constructor))="" throw="" new="" TypeError("Cannot="" call="" a="" class="" as="" function");="" Recorder="exports.Recorder" (function="" Recorder(source,="" cfg)="" _this="this;" _classCallCheck(this,="" Recorder);="" this.config="{" bufferLen:="" 4096,="" numChannels:="" 2,="" mimeType:="" 'audio="" wav'="" this.recording="false;" this.callbacks="{" getBuffer:="" [],="" exportWAV:="" []="" Object.assign(this.config,="" cfg);="" this.context="source.context;" this.node="(this.context.createScriptProcessor" this.context.createJavaScriptNode).call(this.context,="" this.config.bufferLen,="" this.config.numChannels,="" this.config.numChannels);="" this.node.onaudioprocess="function" (e)="" (!_this.recording)="" return;="" buffer="[];" channel="0;" _this.config.numChannels;="" channel++)="" buffer.push(e.inputBuffer.getChannelData(channel));="" _this.worker.postMessage({="" command:="" 'record',="" buffer:="" source.connect(this.node);="" this.node.connect(this.context.destination);="" this="" should="" not="" be="" necessary="" self="{};" this.worker="new" _inlineWorker2.default(function="" recLength="0," recBuffers="[]," sampleRate="undefined," numChannels="undefined;" self.onmessage="function" switch="" (e.data.command)="" case="" 'init':="" init(e.data.config);="" break;="" 'record':="" record(e.data.buffer);="" 'exportWAV':="" exportWAV(e.data.type);="" 'getBuffer':="" getBuffer();="" 'clear':="" clear();="" init(config)="" initBuffers();="" record(inputBuffer)="" numChannels;="" recBuffers[channel].push(inputBuffer[channel]);="" +="inputBuffer[0].length;" exportWAV(type)="" buffers="[];" buffers.push(mergeBuffers(recBuffers[channel],="" recLength));="" interleaved="undefined;" (numChannels="==" 2)="" buffers[1]);="" else="" dataview="encodeWAV(interleaved);" audioBlob="new" Blob([dataview],="" type:="" type="" self.postMessage({="" 'exportWAV',="" data:="" getBuffer()="" 'getBuffer',="" clear()="" initBuffers()="" recBuffers[channel]="[];" mergeBuffers(recBuffers,="" recLength)="" result="new" Float32Array(recLength);="" offset="0;" recBuffers.length;="" result.set(recBuffers[i],="" offset);="" result;="" interleave(inputL,="" inputR)="" length="inputL.length" inputR.length;="" Float32Array(length);="" index="0," inputIndex="0;" while="" (index="" length)="" result[index++]="inputL[inputIndex];" inputIndex++;="" floatTo16BitPCM(output,="" offset,="" input)="" input.length;="" i++,="" s="Math.max(-1," Math.min(1,="" input[i]));="" output.setInt16(offset,="" *="" 0x8000="" 0x7FFF,="" true);="" writeString(view,="" string)="" string.length;="" view.setUint8(offset="" i,="" string.charCodeAt(i));="" encodeWAV(samples)="" ArrayBuffer(44="" samples.length="" 2);="" view="new" DataView(buffer);="" RIFF="" identifier="" 0,="" 'RIFF');="" chunk="" view.setUint32(4,="" 8,="" 'WAVE');="" format="" 12,="" 'fmt="" ');="" view.setUint32(16,="" 16,="" sample="" (raw)="" view.setUint16(20,="" 1,="" count="" view.setUint16(22,="" numChannels,="" rate="" view.setUint32(24,="" sampleRate,="" byte="" (sample="" block="" align)="" view.setUint32(28,="" 4,="" align="" (channel="" bytes="" per="" sample)="" view.setUint16(32,="" bits="" view.setUint16(34,="" data="" 36,="" 'data');="" view.setUint32(40,="" floatTo16BitPCM(view,="" 44,="" samples);="" view;="" },="" self);="" this.worker.postMessage({="" 'init',="" config:="" sampleRate:="" this.context.sampleRate,="" this.config.numChannels="" this.worker.onmessage="function" cb="_this.callbacks[e.data.command].pop();" (typeof="" 'function')="" cb(e.data.data);="" _createClass(Recorder,="" [{="" key:="" record()="" 'stop',="" stop()="" 'clear',="" 'clear'="" getBuffer(cb)="" this.config.callback;="" (!cb)="" Error('Callback="" set');="" this.callbacks.getBuffer.push(cb);="" 'getBuffer'="" exportWAV(cb,="" mimeType)="" mimeType="mimeType" this.config.mimeType;="" this.callbacks.exportWAV.push(cb);="" }],="" 'forceDownload',="" forceDownload(blob,="" filename)="" url="(window.URL" window.webkitURL).createObjectURL(blob);="" link="window.document.createElement('a');" link.href="url;" link.download="filename" 'output.wav';="" click="document.createEvent(&quot;Event&quot;);" click.initEvent("click",="" true,="" link.dispatchEvent(click);="" }]);="" Recorder;="" exports.default="Recorder;" },{"inline-worker":3}],3:[function(require,module,exports){="" inline-worker":4}],4:[function(require,module,exports){="" (global){="" key="" prop="props[key];" prop.configurable="true;" (prop.value)="" prop.writable="true;" Object.defineProperties(target,="" props);="" protoProps);="" staticProps);="" _classCallCheck="function" (instance,="" WORKER_ENABLED="!!(global" global.window="" global.URL="" global.Blob="" global.Worker);="" InlineWorker="(function" InlineWorker(func,="" self)="" InlineWorker);="" (WORKER_ENABLED)="" functionBody="func.toString().trim().match(/^function\s*\w*\s*\([\w\s,]*\)\s*{([\w\W]*?)}$/)[1];" global.Blob([functionBody],="" "text="" javascript"="" }));="" global.Worker(url);="" this.self="self;" this.self.postMessage="function" (data)="" setTimeout(function="" _this.onmessage({="" 0);="" func.call(self);="" _createClass(InlineWorker,="" postMessage:="" postMessage(data)="" _this.self.onmessage({="" InlineWorker;="" }).call(this,typeof="" global="" !="=" "undefined"="" typeof="" window="" {})="" },{}]},{},[1])(1)="" end="" recorder="" js="" webkitURL="" is="" deprecated="" but="" nevertheless="" URL="window.URL" window.webkitURL;="" gumStream;="" stream="" from="" getUserMedia()="" rec;="" Recorder.js="" object="" input;="" MediaStreamAudioSourceNode="" we'll="" recording="" shim="" AudioContext="" when="" it's="" avb.="" window.webkitAudioContext;="" audioContext;="" audio="" context="" to="" help="" us="" record="" recordButton="document.querySelectorAll('.recorder-box" .record');="" stopButton="document.querySelectorAll('.recorder-box" .stop');="" playButton="document.querySelectorAll('.recorder-box" .play');="" thisRecordingList,="" player;="" (i="0;" recordButton.length;="" recordButton[i].disabled="false;" recordButton[i].style.display="inline-block" ;="" recordButton[i].addEventListener('click',="" (event)="" event.preventDefault();="" console.log('recordButton="" clicked');="" constraints="{" audio:="" video:false="" target="event.target;" thisRecordButton="target.parentElement.querySelector('.record');" thisPlayButton="target.parentElement.querySelector('.play');" thisStopButton="target.parentElement.querySelector('.stop');" thisRecordButton.disabled="true;" thisRecordButton.style.display="none" thisPlayButton.disabled="true;" thisPlayButton.style.display="none" thisStopButton.disabled="false;" thisStopButton.style.display="inline-block" navigator.mediaDevices.getUserMedia(constraints).then(="" function(stream)="" console.log('getUserMedia()="" success,="" created,="" initializing="" ...');="" audioContext="new" AudioContext();="" gumStream="stream;" input="audioContext.createMediaStreamSource(stream);" rec="new" Recorder(input,{numChannels:1});="" rec.record();="" console.log('Recording="" started');="" }).catch(="" function(err)="" enable="" the="" button="" fails="" thisRecordButton.disable="false;" stopButton.length;="" stopButton[i].disabled="true;" stopButton[i].style.display="none" stopButton[i].addEventListener('click',="" console.log('stopButton="" thisRecordingList="target.parentElement.querySelector('.recording-list');" rec.stop();="" gumStream.getAudioTracks()[0].stop();="" rec.exportWAV(createDownloadLink);="" playButton.length;="" playButton[i].disabled="true;" playButton[i].style.display="none" playButton[i].addEventListener('click',="" console.log('playButton="" player="thisRecordingList.querySelectorAll('audio')[0];" player.play();="" detectFinished(player,thisRecordButton,thisStopButton,thisPlayButton);="" detectFinished(player,thisRecordButton,thisStopButton,thisPlayButton)="" player.addEventListener("ended",="" function(){="" player.currentTime="0;" console.log("playback="" ended");="" console.log(thisRecordButton);="" createDownloadLink="" (blob)="" au="document.createElement('audio');" li="document.createElement('li');" au.controls="true;" au.src="url;" remove="" download="" forces="" browser="" donwload="" file="" using="" filename="" link.innerHTML="&times;" add="" element="" li.appendChild(au);="" li.appendChild(link);="" replace="" ol="" thisRecordingList.innerHTML="" thisRecordingList.appendChild(li);="" catch(e)="" console.error(e);="" (function()="" (!__sections__["quiz"]="" !window.DesignMode)="" try="" Fill="" In="" The="" Blank="" radioBtns="==" 'undefined')="" radioBtns.length;="" radioBtns[i].addEventListener('change',="" function(event)="" form="target.parentElement;" correct="form.dataset.correct;" answer="form.querySelector('input[name=answer-radio]:checked').value;" response="form.querySelector('.response');" (answer="==" correct)="" response.innerHTML="<span class=&quot;correct&quot;>Correct!</span>" div=""></r.length;o++)s(r[o]);return>